"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var FormUtility_1 = __importDefault(require("../helpers/FormUtility"));
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        this.isSecondSubmit = false;
        var formElements = document.querySelectorAll("[".concat(constants_1.DATA_FORM, "]"));
        if (!formElements || !((formElements === null || formElements === void 0 ? void 0 : formElements.length) > 0)) {
            return;
        }
        formElements === null || formElements === void 0 ? void 0 : formElements.forEach(function (formElement) {
            var type = formElement === null || formElement === void 0 ? void 0 : formElement.dataset.form;
            var submit = formElement === null || formElement === void 0 ? void 0 : formElement.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT, "]"));
            var submitText = submit === null || submit === void 0 ? void 0 : submit.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT_TEXT, "]"));
            var submitIcon = submit === null || submit === void 0 ? void 0 : submit.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT_ICON, "]"));
            var formObject = {
                type: type,
                submit: submit,
                submitText: submitText,
                submitIcon: submitIcon,
            };
            _this.setValidationSchema(formElement);
            _this.submitHandler(formElement, formObject);
            if (sessionStorage.getItem('formSent') === type) {
                sessionStorage.removeItem('formSent');
                _this.revalidateInputs(formElement);
            }
        });
    }
    Form.getChecked = function (formElement, string) {
        var checkboxes = this.getAllFields(formElement, string);
        if (checkboxes && checkboxes.length > 0) {
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    return true;
                }
            }
            return false;
        }
    };
    Form.getValue = function (formElement, string) {
        var field = this.getField(formElement, string);
        return field ? field.value : '';
    };
    Form.getFiles = function (formElement, string) {
        var input = this.getField(formElement, string);
        var FileList = [];
        if (!input)
            return FileList;
        for (var i = 0; i < input.files.length; i++) {
            FileList.push(input.files[i]);
        }
        return FileList;
    };
    Form.checkValidity = function (validationSchema, validate, fieldWrap) {
        var _this = this;
        var fieldError = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
        var fields = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        validationSchema === null || validationSchema === void 0 ? void 0 : validationSchema.validate(validate).then(function () {
            // remove error styling and hide error message
            if (fieldError && !fieldError.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
                fieldError.classList.add(constantsClasses_1.CLASS_D_NONE);
            }
            if (fieldWrap && fieldWrap.classList.contains(constantsClasses_1.CLASS_INVALID)) {
                fieldWrap.classList.remove(constantsClasses_1.CLASS_INVALID);
            }
            if (fields && fields.length > 0) {
                fields.forEach(function (field) {
                    if (field && field.classList.contains(constantsClasses_1.CLASS_INVALID)) {
                        field.classList.remove(constantsClasses_1.CLASS_INVALID);
                    }
                });
            }
        }).catch(function (error) {
            _this.setError(error, fieldWrap);
        });
    };
    Form.getField = function (formElement, string) {
        return formElement === null || formElement === void 0 ? void 0 : formElement.querySelector("[".concat(constants_1.DATA_FORM_FIELD, "='").concat(string, "']"));
    };
    Form.getAllFields = function (formElement, string) {
        return formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "='").concat(string, "']"));
    };
    Form.getFieldWrap = function (formElement, string) {
        var field = this.getField(formElement, string);
        var fieldWrap = field === null || field === void 0 ? void 0 : field.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
        return fieldWrap ? fieldWrap : undefined;
    };
    /**
     * Show error and set correct error message
     *
     * @param error
     * @param fieldWrap
     * @private
     */
    Form.setError = function (error, fieldWrap) {
        if (!fieldWrap) {
            return;
        }
        var fieldError = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
        var fieldErrorText = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR_TEXT, "]"));
        var fields = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        if (fieldErrorText) {
            fieldErrorText.innerText = error.message;
        }
        if (fieldError && fieldError.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            fieldError.classList.remove(constantsClasses_1.CLASS_D_NONE);
        }
        if (fieldWrap && !fieldWrap.classList.contains(constantsClasses_1.CLASS_INVALID)) {
            fieldWrap.classList.add(constantsClasses_1.CLASS_INVALID);
        }
        if (fields && fields.length > 0) {
            fields.forEach(function (field) {
                field.classList.add(constantsClasses_1.CLASS_INVALID);
            });
        }
    };
    Form.prototype.revalidateInputs = function (formElement) {
        var validationSchema = this.setValidationSchema(formElement);
        var formInputs = formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        formInputs === null || formInputs === void 0 ? void 0 : formInputs.forEach(function (element) {
            var fieldWrap = element === null || element === void 0 ? void 0 : element.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
            if (!fieldWrap) {
                return;
            }
            var elType = element.type;
            var identifier = element.dataset.formField;
            var currentValidationSchema = validationSchema.fields[identifier];
            if (['text', 'textarea', 'email', 'tel', 'number'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('keyup', function () {
                    Form.checkValidity(currentValidationSchema, Form.getValue(formElement, identifier), fieldWrap);
                });
                return;
            }
            if (['checkbox', 'radio'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () {
                    Form.checkValidity(currentValidationSchema, Form.getChecked(formElement, identifier), fieldWrap);
                });
                return;
            }
            if (['number', 'date', 'select-one'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () {
                    Form.checkValidity(currentValidationSchema, Form.getValue(formElement, identifier), fieldWrap);
                });
                return;
            }
            if (['file'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () {
                    Form.checkValidity(currentValidationSchema, Form.getFiles(formElement, identifier), fieldWrap);
                });
                return;
            }
        });
    };
    Form.prototype.setValidationSchema = function (formElement) {
        var formErrorMessages;
        try {
            formErrorMessages = JSON.parse(formElement.dataset.errorMessages);
            return FormUtility_1.default.getFormObject(formElement, formErrorMessages);
        }
        catch (e) {
            console.error(e);
            return;
        }
    };
    Form.prototype.submitHandler = function (formElement, formObject) {
        var _this = this;
        formElement === null || formElement === void 0 ? void 0 : formElement.addEventListener('submit', function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.validateObject(e, formElement, formObject)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
    };
    Form.prototype.disableSubmit = function (formObject) {
        if (formObject.submit) {
            formObject.submit.disabled = true;
        }
        if (formObject.submitText && !formObject.submitText.classList.contains(constantsClasses_1.CLASS_OPACITY_0)) {
            formObject.submitText.classList.add(constantsClasses_1.CLASS_OPACITY_0);
        }
        if (formObject.submitIcon && formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            formObject.submitIcon.classList.remove(constantsClasses_1.CLASS_D_NONE);
        }
        if (formObject.submitIcon && !formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_ROTATING)) {
            formObject.submitIcon.classList.add(constantsClasses_1.CLASS_ROTATING);
        }
    };
    Form.prototype.enableSubmit = function (formObject) {
        if (formObject.submit) {
            formObject.submit.disabled = false;
        }
        if (formObject.submitText && formObject.submitText.classList.contains(constantsClasses_1.CLASS_OPACITY_0)) {
            formObject.submitText.classList.remove(constantsClasses_1.CLASS_OPACITY_0);
        }
        if (formObject.submitIcon && !formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            formObject.submitIcon.classList.add(constantsClasses_1.CLASS_D_NONE);
        }
        if (formObject.submitIcon && formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_ROTATING)) {
            formObject.submitIcon.classList.remove(constantsClasses_1.CLASS_ROTATING);
        }
    };
    // private validateObject(event: SubmitEvent, formElement: HTMLFormElement, formObject: FormObject): void {
    //   const formValues: Record<string, unknown> = FormUtility.getFormValues(formElement);
    //
    //   if (!formValues) {
    //     return;
    //   }
    //
    //   const validationSchema: yupObject = this.setValidationSchema(formElement);
    //
    //   validationSchema?.validate(formValues, {abortEarly: false})
    //                   .then((): void => {
    //                     sessionStorage.setItem('formSent', formObject.type);
    //                   })
    //                   .catch((error): void => {
    //                     event.preventDefault();
    //                     this.disableSubmit(formObject);
    //                     this.revalidateInputs(formElement);
    //
    //                     error?.inner?.forEach((error: yup.ValidationError): void => {
    //                       if (!error || error && !error.path) {
    //                         return;
    //                       }
    //
    //                       const fieldWrap: HTMLDivElement = Form.getFieldWrap(formElement, error.path);
    //
    //                       if (!fieldWrap) {
    //                         return;
    //                       }
    //
    //                       Form.setError(error, fieldWrap);
    //                     });
    //
    //                     const firstError: HTMLElement = <HTMLElement>formElement?.querySelector(`.${CLASS_INVALID}`);
    //                     firstError?.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
    //
    //                     this.revalidateInputs(formElement);
    //
    //                     setTimeout((): void => {
    //                       this.enableSubmit(formObject);
    //                     }, 600);
    //                   });
    // }
    Form.prototype.validateObject = function (event, formElement, formObject) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var formValues, validationSchema, error_1, firstError;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formValues = FormUtility_1.default.getFormValues(formElement);
                        if (!formValues) {
                            return [2 /*return*/];
                        }
                        if (this.isSecondSubmit) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        validationSchema = this.setValidationSchema(formElement);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, validationSchema.validate(formValues, { abortEarly: false })];
                    case 2:
                        _b.sent();
                        sessionStorage.setItem('formSent', formObject.type);
                        this.isSecondSubmit = true;
                        formObject.submit.click();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        event.preventDefault();
                        this.disableSubmit(formObject);
                        this.revalidateInputs(formElement);
                        (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.inner) === null || _a === void 0 ? void 0 : _a.forEach(function (err) {
                            if (!err || !err.path) {
                                return;
                            }
                            var fieldWrap = Form.getFieldWrap(formElement, err.path);
                            if (!fieldWrap) {
                                return;
                            }
                            Form.setError(err, fieldWrap);
                        });
                        firstError = formElement === null || formElement === void 0 ? void 0 : formElement.querySelector(".".concat(constantsClasses_1.CLASS_INVALID));
                        firstError === null || firstError === void 0 ? void 0 : firstError.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
                        this.revalidateInputs(formElement);
                        setTimeout(function () {
                            _this.enableSubmit(formObject);
                        }, 600);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Form;
}());
exports.default = Form;
